import { ComponentContentTypes } from '@lib/types/content-types'
import { buildContentRenderer } from '../generic'
import { ImageAsset } from '@components/asset/image'
import { LottieAnimationAsset } from '@components/asset/lottie-animation'
import { LottieInteractiveAnimationAsset } from '@components/asset/lottie-animation/lottie-interactive-animation-asset'
import { VideoAsset } from '@components/asset/video'

const contentTypeMap = {
  [ComponentContentTypes.AssetImage]: ImageAsset,
  [ComponentContentTypes.AssetLottieAnimation]: LottieAnimationAsset,
  [ComponentContentTypes.AssetLottieInteractiveAnimation]: LottieInteractiveAnimationAsset,
  [ComponentContentTypes.AssetVideo]: VideoAsset,
} as const

export const AssetRenderer = buildContentRenderer(contentTypeMap)
